<template>
  <div class="ft">
    <dt class="lft">
      <img src="../assets/img/logoFt.png" alt="同济大学退休办" />
    </dt>
    <!-- <dd class="rig ftFonts">
          <h4>联系我们</h4>
          <div class="contact-info">
            <span>同济大学退休办</span>
            <span>E-mail：xxxxxxxxx@tongji.edu.cn</span>
          </div>
          <div class="copyright">
            <span>Copyright © 2024 同济大学版权所有</span>
            <span>沪ICP备10014176号</span>
          </div>
          <div class="beian">沪公网安备：31009102000038号</div>
        </dd> -->
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="less" scoped>
@import '../styles/base/_variables.less';

.ft {
  width: 100%;
  background: #333;
  color: #7f7f7f;
  align-items: center;
  height: 80px;
  display: flex;
  padding-left: 3vw;
}

   /* 移动端高度 */
@media screen and (max-width: @screen-sm) {
  .ft {
    height: 50px;
  }
}

.lft {
  height: 100%;
  display: flex;
  align-items: center;
}

.lft img {
  max-height: 100%;
  width: auto;
  object-fit: contain;
}


</style>